
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discover/podcast/[country]",
      function () {
        return require("private-next-pages/discover/podcast/[country].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discover/podcast/[country]"])
      });
    }
  